import axios from "axios";
import baseUrl from "../../../../../utilities/baseUrl";

const usePostRate = async postData => {
  try {
    const path = baseUrl + "/internalpost/v1/postRate";

    const token = localStorage.getItem("token");

    const postBody = {
      addressId: postData.SAddress,
      getterAddressId: postData.RAddress,
      method: postData.postExpress,
      value: postData.totalCost,
      data: postData.rowsData,
      methodPayment: postData.methodPayment,
      serviceTypeId: postData.serviceTypeId,
      totalSpecialService: postData.totalSpecialService,
      needSMS: postData.needSMS,
      needPrint: postData.needPrint,
      internalSectionId: 1,
      collectingType: 1,
      needCollecting: postData.needCollecting,
      isCod: postData.isCod,
      isBulk: false,
    };

    const result = await axios.post(path, postBody, {
      headers: {
        Authorization: "Bearer " + token,
      },
      timeout: 18000,
    });

    if (result.status === 200) {
      return {
        chaparData: result.data.data,
        Data: postData.postItem,
      };
    }
  } catch (error) {
    return { Data: postData.postItem, chaparData: { quote: 0 } };
  }
};

export default usePostRate;
